import { PastStay } from '../../model/past-stay';

export class PastStayBuilder {

  public static buildStay(data: any): PastStay {
    return {
      stayId: data.stayId,
      firstName: data.guest.firstName,
      lastName: data.guest.lastName,
      hotelMnemonic: data.hotelMnemonic,
      checkInDate: data.checkInDate,
      checkOutDate: data.checkOutDate,
      confirmationNumber: data.confirmationNumber
    };
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/past-stay.builder.ts